import React       from 'react';

import values      from '../../../../values';
import Context     from '../../../../context';
import validations from '../../../../validations';

import * as Yup from 'yup';

import { useFormik      } from 'formik';
import { useTranslation } from 'react-i18next';

import { IItem                  } from '../../../../types/common.interface';
import { locationNamespace      } from "../../../../types/location.namespace";
import { ICreateAndUpdateParent } from '../../../../types/parent.interface';
import {
  CustomModal,
  CustomInput,
  CustomButton2,
  ResponsiveView,
  LocationDropdowns,
  CustomDropdownSearch,
} from '../../../../components';

import './index.sass';

const Update: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();

  const { showModal, setShowModal, updateFunction, isLoading, selectedParent } = React.useContext(Context.ParentScreen);

  const [selectedGender, setSelectedGender] = React.useState<IItem | undefined>();

  const [selectedArea        , setSelectedArea        ] = React.useState<locationNamespace.area        .index | undefined>(undefined);
  const [selectedCity        , setSelectedCity        ] = React.useState<locationNamespace.city        .index | undefined>(undefined);
  const [selectedProvince    , setSelectedProvince    ] = React.useState<locationNamespace.province    .index | undefined>(undefined);
  const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<locationNamespace.neighborhood.index | undefined>(undefined);

  const [dropdownErrors, setDropdownErrors] = React.useState({province: '', gender  : '', city    : ''});

  console.log(selectedParent?.parentInformation);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<ICreateAndUpdateParent>({
    initialValues: {
      ...selectedParent,
      kartNumber : selectedParent?.financial?.kartNumber  || undefined,
      shabaNumber: selectedParent?.financial?.shabaNumber || undefined,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      lastName   : validations.yupValidations.lastName   ,
      firstName  : validations.yupValidations.firstName  ,
      kartNumber : validations.yupValidations.kartNumber ,
      phoneNumber: validations.yupValidations.phoneNumber,
      shabaNumber: validations.yupValidations.shabaNumber,
    }),
    onSubmit: (values: ICreateAndUpdateParent, { setSubmitting }): void | Promise<any> => {
      const formValues: ICreateAndUpdateParent = {
        ...values,
        gender: selectedGender,

        city        : selectedCity         ? selectedCity        ?._id : selectedParent?.parentInformation?.city        ?._id,
        area        : selectedArea         ? selectedArea        ?._id : selectedParent?.parentInformation?.area        ?._id,
        province    : selectedProvince     ? selectedProvince    ?._id : selectedParent?.parentInformation?.province    ?._id,
        neighborhood: selectedNeighborhood ? selectedNeighborhood?._id : selectedParent?.parentInformation?.neighborhood?._id,
      };
      if (selectedGender) {
        Promise.resolve(updateFunction!(formValues)).catch(() => setSubmitting(false));
      }
    },
  });

  function submitHandler(): void {
    let errors = { city: '', gender: '', province: '', area: '', neighborhood: '' };
    if (!selectedGender) {errors = { ...errors, gender: t("gender_is_required") };}
    setDropdownErrors(errors);
    formik.submitForm();
  }

  function onSelectProvince(province: locationNamespace.province.index): void {
    setSelectedProvince(province);
    setSelectedNeighborhood(undefined);
    setSelectedCity        (undefined);
    setSelectedArea        (undefined);
  }

  function onSelectCity(city: locationNamespace.city.index): void {
    setSelectedNeighborhood(undefined);
    setSelectedCity        (city     );
    setSelectedArea        (undefined);
    setDropdownErrors({
      ...dropdownErrors,
      city: '',
    });
  }

  function onSelectArea(area: locationNamespace.area.index): void {
    setSelectedArea(area);
    setSelectedNeighborhood(undefined);
  }

  function onSelectNieghborhood(neighborhood: locationNamespace.neighborhood.index): void {
    setSelectedNeighborhood(neighborhood);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect((): void => {
    setSelectedGender(values.dropdownItems.GENDER.find((item) => selectedParent?.gender === item?.value));

    setSelectedNeighborhood(selectedParent?.parentInformation?.neighborhood);
    setSelectedProvince    (selectedParent?.parentInformation?.province    );
    setSelectedCity        (selectedParent?.parentInformation?.city        );
    setSelectedArea        (selectedParent?.parentInformation?.area        );

  }, [selectedParent]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-update-modal-container">
      <form onSubmit={submitHandler}>
        <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "UPDATE"}>
          <ResponsiveView.Container className="create-form-content">
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6} className="form-colum">
                <CustomInput
                  id            = 'firstName'
                  name          = 'firstName'
                  label         = 'نام'
                  value         = { formik.values.firstName }
                  formikProps   = { { onBlur: formik.handleBlur } }
                  onValueChange = { formik.handleChange }
                  error     = { formik.errors.firstName && formik.touched.firstName }
                  errorText = { formik.errors.firstName }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6} className="form-colum">
                <CustomInput
                  id="lastName"
                  name="lastName"
                  label={t("firstName")}
                  value={formik.values.lastName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.lastName && formik.touched.lastName}
                  errorText={formik.errors.lastName}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("lastName")}
                  value={formik.values.phoneNumber}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.phoneNumber && formik.touched.phoneNumber}
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("gender")}</label>
                <CustomDropdownSearch
                  items={values.dropdownItems.GENDER}
                  itemName="name"
                  placeHolder="جنسیت"
                  defaultItem={selectedGender}
                  onSelectItem={(event: any) => {
                    setSelectedGender(event);
                    setDropdownErrors({ ...dropdownErrors, gender: "" });
                  }}
                />
                <div className="error">{dropdownErrors.gender !== "" && dropdownErrors.gender}</div>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            {/* TODO ============================================================================================= */}
            {/* TODO ============================================================================================= */}
            {/* TODO ============================================================================================= */}
            {/* TODO :: [ ] => Add location dropdowns hear ------------------------------------------------------- */}
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6} className="form-colum dropdown">
                <LocationDropdowns.Province
                  defaultItem  = { selectedProvince }
                  onSelectItem = { onSelectProvince }
                  isError   = { dropdownErrors.province !== '' }
                  errorText = { dropdownErrors.province        }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6} className="form-colum dropdown">
                <LocationDropdowns.City
                  defaultItem      = { selectedCity     }
                  onSelectItem     = { onSelectCity     }
                  selectedProvince = { selectedProvince }
                  isError   = { dropdownErrors.city !== '' }
                  errorText = { dropdownErrors.city        }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6} className="form-colum dropdown">
                <LocationDropdowns.Area
                  defaultItem      = { selectedArea     }
                  onSelectItem     = { onSelectArea     }
                  selectedCity     = { selectedCity     }
                  selectedProvince = { selectedProvince }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6} className="form-colum dropdown">
                <LocationDropdowns.Neighborhood
                  defaultItem      = { selectedNeighborhood }
                  onSelectItem     = { onSelectNieghborhood }
                  selectedCity     = { selectedCity         }
                  selectedArea     = { selectedArea         }
                  selectedProvince = { selectedProvince     }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6} className="form-colum">
                <CustomInput
                  id           = 'shabaNumber'
                  name         = 'shabaNumber'
                  label        = 'شماره شباء'
                  value        = { formik.values.shabaNumber }
                  error        = { formik.errors.shabaNumber && formik.touched.shabaNumber }
                  maxLength    = { 24 }
                  errorText    = { formik.errors.shabaNumber }
                  formikProps  = {{ onBlur: formik.handleBlur }}
                  onValueChange= { formik.handleChange }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6} className='form-colum'>
                <CustomInput
                  id           = 'kartNumber'
                  name         = 'kartNumber'
                  label        = 'شماره کارت بانکی'
                  value        = { formik.values.kartNumber }
                  error        = { formik.errors.kartNumber && formik.touched.kartNumber }
                  maxLength    = { 16 }
                  errorText    = { formik.errors.kartNumber }
                  formikProps  = {{ onBlur: formik.handleBlur }}
                  onValueChange= { formik.handleChange }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br/>
            <ResponsiveView.Row className='form-row'>
              <ResponsiveView.Column large={3} medium={4} small={6} className='form-colum'>
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={3} medium={4} small={6} className="form-colum">
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Update;
